import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import Button from './Button';
import Logo from './Logo';

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: { staggerChildren: 0.12, delayChildren: 0.1 }
    }
};

const itemVariants = {
    hidden: { opacity: 0, y: 18 },
    visible: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }
    }
};

const Hero = () => {
    const { t, i18n } = useTranslation();

    return (
        <section id="hero" className="relative min-h-screen flex items-center overflow-hidden bg-gray-50 dark:bg-dark pt-40 pb-24 transition-colors duration-300">
            {/* Sıcak ambient dekor — stok fotoğraf yerine marka renklerinden organik ışık */}
            <div className="absolute -top-24 -right-24 w-[520px] h-[520px] bg-primary/25 dark:bg-primary/15 rounded-full blur-[120px] mix-blend-multiply dark:mix-blend-screen" aria-hidden="true"></div>
            <div className="absolute bottom-0 -left-32 w-[420px] h-[420px] bg-secondary/20 dark:bg-secondary/15 rounded-full blur-[110px] mix-blend-multiply dark:mix-blend-screen" aria-hidden="true"></div>
            <div className="absolute top-1/3 left-1/2 w-[300px] h-[300px] bg-accent/25 dark:bg-accent/15 rounded-full blur-[100px] mix-blend-multiply dark:mix-blend-screen" aria-hidden="true"></div>

            <div className="container relative z-10">
                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                    className="max-w-4xl mx-auto text-center flex flex-col items-center"
                >
                    {/* İkon rozeti */}
                    <motion.div variants={itemVariants} className="mb-8 p-3 rounded-3xl bg-white dark:bg-white/5 border border-gray-200 dark:border-white/10 shadow-lg shadow-primary/10">
                        <Logo size={44} showWordmark={false} />
                    </motion.div>

                    <motion.h1
                        variants={itemVariants}
                        className="font-body font-bold text-6xl md:text-8xl mb-7 leading-[0.95] tracking-tight text-gray-900 dark:text-white text-balance"
                    >
                        {t('hero.title')}
                    </motion.h1>

                    <motion.p
                        variants={itemVariants}
                        className="font-body text-lg md:text-xl text-gray-600 dark:text-gray-300 mb-10 max-w-xl leading-relaxed"
                    >
                        {t('hero.subtitle')}
                    </motion.p>

                    <motion.div variants={itemVariants} className="flex flex-col sm:flex-row gap-3 items-center">
                        <a href="/register" target="_blank" rel="noopener noreferrer">
                            <Button variant="primary" size="lg">
                                {t('hero.cta')}
                                <ArrowRight size={18} />
                            </Button>
                        </a>
                        <a href="https://sinav.uz" target="_blank" rel="noopener noreferrer">
                            <Button variant="outline" size="lg" className="text-gray-700 dark:text-gray-200 hover:bg-white dark:hover:bg-white/10">
                                {i18n.language === 'tr' ? 'Konuşma Sınavı' : 'Imtihon markazi'}
                            </Button>
                        </a>
                    </motion.div>

                    <motion.p variants={itemVariants} className="mt-8 text-sm font-medium text-gray-500 dark:text-gray-400">
                        {t('hero.eyebrow')}
                    </motion.p>
                </motion.div>
            </div>
        </section>
    );
};

export default Hero;
